// StandardArenaAudioAdapter.ts - Desktop & standard browser audio platform adapter
import { IArenaAudioPlatformAdapter } from './IArenaAudioPlatformAdapter';

export class StandardArenaAudioAdapter implements IArenaAudioPlatformAdapter {
  public readonly platformName = 'standard';

  public createAudioContext(): AudioContext | null {
    if (typeof window === 'undefined') return null;
    const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioCtx) return null;

    try {
      return new AudioCtx({ sampleRate: 48000 });
    } catch {
      try {
        return new AudioCtx();
      } catch {
        return null;
      }
    }
  }

  public prewarmAndUnlock(ctx: AudioContext, _isVoiceActive?: boolean): void {
    if (typeof window === 'undefined') return;

    if (ctx.state === 'suspended' || (ctx.state as any) === 'interrupted') {
      ctx.resume().catch(() => {});
    }

    try {
      const buffer = ctx.createBuffer(1, 1, 22050);
      const source = ctx.createBufferSource();
      source.buffer = buffer;
      source.connect(ctx.destination);
      source.start(0);
    } catch {}
  }

  public onForeground(ctx: AudioContext | null, _isVoiceActive: boolean): void {
    if (ctx && (ctx.state === 'suspended' || (ctx.state as any) === 'interrupted')) {
      ctx.resume().catch(() => {});
    }
  }

  public onBackground(_ctx: AudioContext | null): void {
    // No explicit suspend needed
  }

  public configureSession(_isVoiceActive: boolean): void {}

  public dispose(): void {}
}
